// extracted by mini-css-extract-plugin
module.exports = {"lds_ring":"Spinner_lds_ring__3Tzww","lds-ring":"Spinner_lds-ring__12uUI"};